var PREV_RESULT_SIZE = 30;
var NEXT_RESULT_SIZE = 15;
var MAX_USER_MENTION_COUNT = 10;
var MAX_USER_SUGGESTION_COUNT = 15;
var USER_MENTION_TEMP_CHAR = '@';
export { MAX_USER_MENTION_COUNT as M, NEXT_RESULT_SIZE as N, PREV_RESULT_SIZE as P, USER_MENTION_TEMP_CHAR as U, MAX_USER_SUGGESTION_COUNT as a };